import Vue from 'vue';
import Vuex from 'vuex';
import { loadLanguageAsync } from '@/i18n.ts';

export enum SnackbarStatus {
  ERROR = 'red',
  SUCCESS = 'green',
}

export interface Snackbar {
  state: SnackbarStatus;
  text: string;
}

export interface SnackbarState {
  snackbar: Snackbar | null;
}

Vue.use(Vuex);

export const createStore = () => {
  const store = new Vuex.Store({
    state: {
      account: null,
      chainID: '',
      token: null,
      connectMethod: null,
      lang: 'en',
      referSidebar: false,
      snackbar: { state: '', text: '' },
      activity: {
        start: new Date(Date.UTC(2020, 11, 21, 3, 0, 0)).getTime(),
        end: new Date(Date.UTC(2021, 0, 1, 23, 59, 59)).getTime(),
      },
    },
    mutations: {
      setAccount(state, account) {
        state.account = account;
      },
      setChainID(state, chainID) {
        state.chainID = chainID;
      },
      setToken(state, token) {
        state.token = token;
      },
      setConnectMethod(state, method) {
        state.connectMethod = method;
      },
      setLanguage(state, lang) {
        state.lang = lang;
      },
      setReferSidebar(state, referSidebar) {
        state.referSidebar = referSidebar;
      },
      setSnackbarSuccess(state, text) {
        state.snackbar = {
          state: SnackbarStatus.SUCCESS,
          text,
        };
      },
      setSnackbarError(state, text) {
        state.snackbar = {
          state: SnackbarStatus.ERROR,
          text,
        };
      },
      resetSnackbar(state) {
        state.snackbar = { state: '', text: '' };
      },
    },
    getters: {
      getAccount: (state) => state.account,
      chainID: (state) => state.chainID,
      token: (state) => state.token,
      connectMethod: (state) => state.connectMethod,
      lang: (state) => state.lang,
      referSidebar: (state) => state.referSidebar,
      snackbar: (state) => state.snackbar,
      activity: (state) => state.activity,
    },
    actions: {
      loadLanguage: ({ commit }, { lang, context }) => {
        loadLanguageAsync(lang, context.$i18n);
        commit('setLanguage', lang);
      },
    },
    modules: {
    },
  });

  store.subscribe(({ type }, state) => {
    // console.log(state);
    const local = {
      lang: state.lang,
    };
    if (type.startsWith('setLanguage')) {
      localStorage.setItem('store', JSON.stringify(local));
    }
  });

  restoreFromLocal(store);

  return store;
};


export function restoreFromLocal(store: any): void {
  const saved = localStorage.getItem('store');
  if (!saved) {
    return;
  }
  const parsed = JSON.parse(saved);
  store.state.lang = parsed.lang;
  store.replaceState(store.state);
}
